import React from "react"
import { goats, wool_yellow, wool_white } from "../res/imgs/heros"
import Hero from "../Atoms/Hero"
import { useLocation } from "react-router-dom"
import { pathnames } from "../config"
import { useTranslation } from "react-i18next"

function HeroSelector() {
    const location = useLocation()
    const { t } = useTranslation()

    switch (location.pathname) {
        case pathnames[0]:
            return (
                <Hero
                    title={t("heroes.titles.home")}
                    subtitle={t("heroes.subtitles.home")}
                    bg={goats}
                />
            )
        case pathnames[1]:
            return (
                <Hero
                    title={t("heroes.titles.cashmere")}
                    subtitle={t("heroes.subtitles.cashmere")}
                    bg={wool_white}
                />
            )
        case pathnames[2]:
            return (
                <Hero
                    title={t("heroes.titles.products")}
                    subtitle={t("heroes.subtitles.products")}
                    bg={wool_yellow}
                />
            )
        default:
            return <></>
    }
}

export default HeroSelector
